import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthPage from "./public_page/Auth/AuthPage";
import Dashboard from "./private_page/Dashboard";
import { Permission } from "./PermissionRoute";
import { userServices } from "./APIServices/userServices";
import AppDashboard from "./private_page/AppDashboard";

function App() {
  const [currentUserData, setCurrentUserData] = useState("");
  const { LoginPermission, AllPermission } = Permission;
  const auth = JSON.parse(localStorage.getItem("token"));

  const getCurrectLoginUser = async () => {
    let data = await userServices.getCurrectLoginUser()
    setCurrentUserData(data?.data || "")
  }

  useEffect(() => {
    if(auth){
      getCurrectLoginUser()
    }
  }, [auth]);
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing Page */}
        <Route path="/" element={<AuthPage status="startLogin" />} />

        {/* Public Home */}
        <Route element={<LoginPermission auth={auth} />}>
          <Route path="login" element={<AuthPage status="startLogin" />} />
        </Route>

        {/* Public Home */}
        <Route element={<AllPermission auth={auth} currentUserData={currentUserData} />}>
          <Route path="home" element={<AppDashboard getCurrectLoginUser={getCurrectLoginUser} currentUserData={currentUserData} />} />
          <Route path="home/:app" element={<Dashboard getCurrectLoginUser={getCurrectLoginUser} currentUserData={currentUserData} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;